import React, {useEffect} from 'react';
import {isSpecialSmallDeviceDetect} from '../../util/isSpecialSmallDeviceDetect';
import DesktopWardDashboard from './desktopWardDashboard';
import {loadWardList} from '../../store/reducers/ward';
import {useDispatch} from 'react-redux';
import {useWardDashboardStyles} from './useWardDashboardStyles';

const WardDashboard = () => {
    const dispatch = useDispatch();
    const classes = useWardDashboardStyles();

    // Mobile dashboard check
    const isSmallDevice = isSpecialSmallDeviceDetect();

    useEffect(() => {
        dispatch(loadWardList());
    }, []);

    // TODO: Implement the mobile dashboard
    return (
        <div className={classes.root}>
            {/*{isSmallDevice && <MobileWardDashboard/>}*/}
            {/*{!isSmallDevice && <DesktopWardDashboard/>}*/}
            <DesktopWardDashboard/>
        </div>
    );
};

export default WardDashboard;